import * as PropTypes from 'prop-types';
import * as React from 'react';
import { NestingChild } from './NestingChild';
import { NestingContext } from './NestingContext';
import { NestingRoot } from './NestingRoot';
export var NestingAuto = /*#__PURE__*/function () {
  var NestingAuto = function NestingAuto(props) {
    return /*#__PURE__*/React.createElement(NestingContext.Consumer, null, function (contextValue) {
      var hasContext = !!contextValue;
      var Component = hasContext ? NestingChild : NestingRoot;
      return /*#__PURE__*/React.createElement(Component, props);
    });
  };
  NestingAuto.displayName = 'NestingAuto';
  NestingAuto.propTypes = {
    children: PropTypes.func.isRequired
  };
  return NestingAuto;
}();
//# sourceMappingURL=NestingAuto.js.map
